const pagPromise = Promise.resolve({
  BusCode: 0,
  Code: 0,
  Data: {
    Data: []
  },
  Msg: null
});

const noPagePromise = Promise.resolve({
  BusCode: 0,
  Code: 0,
  Data: [],
  Msg: null
});

export { pagPromise, noPagePromise };



// WEBPACK FOOTER //
// ./src/api/setPromise.js